/** @format */

/**
 * Генерирует массив тиков для оси X, гарантируя что 0 всегда присутствует
 * @param niceDomain - максимальное абсолютное значение домена
 * @returns массив тиков
 */
export const generateTicks = (niceDomain: number): number[] => {
  const tickCount = 5;
  const step = (niceDomain * 2) / (tickCount - 1);
  const ticks = [];

  for (let i = 0; i < tickCount; i++) {
    ticks.push(-niceDomain + i * step);
  }

  // Убеждаемся, что 0 точно присутствует
  if (!ticks.includes(0)) {
    ticks.push(0);
    ticks.sort((a, b) => a - b);
  }

  return ticks;
};

